export default "__VITE_ASSET__C87aV_Td__"